/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export {Animation as ÉµAnimation} from './dsl/animation';
export {AnimationStyleNormalizer as ÉµAnimationStyleNormalizer, NoopAnimationStyleNormalizer as ÉµNoopAnimationStyleNormalizer} from './dsl/style_normalization/animation_style_normalizer';
export {WebAnimationsStyleNormalizer as ÉµWebAnimationsStyleNormalizer} from './dsl/style_normalization/web_animations_style_normalizer';
export {AnimationDriver as ÉµAnimationDriver, NoopAnimationDriver as ÉµNoopAnimationDriver} from './render/animation_driver';
export {AnimationEngine as ÉµAnimationEngine} from './render/animation_engine_next';
export {CssKeyframesDriver as ÉµCssKeyframesDriver} from './render/css_keyframes/css_keyframes_driver';
export {CssKeyframesPlayer as ÉµCssKeyframesPlayer} from './render/css_keyframes/css_keyframes_player';
export {containsElement as ÉµcontainsElement, invokeQuery as ÉµinvokeQuery, matchesElement as ÉµmatchesElement, validateStyleProperty as ÉµvalidateStyleProperty} from './render/shared';
export {WebAnimationsDriver as ÉµWebAnimationsDriver, supportsWebAnimations as ÉµsupportsWebAnimations} from './render/web_animations/web_animations_driver';
export {WebAnimationsPlayer as ÉµWebAnimationsPlayer} from './render/web_animations/web_animations_player';
export {allowPreviousPlayerStylesMerge as ÉµallowPreviousPlayerStylesMerge} from './util';
